module.exports = __webpack_public_path__ + "img/potion_img_05.67f11699.png";